const returnZero = (property) => {
    return property ?? 0
}

export default ({ marginTop, marginRight, marginBottom, marginLeft }) => {
    return `${returnZero(marginTop)} ${returnZero(marginRight)} ${returnZero(marginBottom)} ${returnZero(marginLeft)}`
}